function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import React from 'react';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
var HtmlComponentContainer = styled.div(function(param) {
    var theme = param.theme;
    var _theme_colors, _theme_spacing, _theme_radius, _theme_shadows, _theme_spacing1, _theme_typography, _theme_breakpoints, _theme_spacing2, _theme_spacing3;
    return _define_property({
        width: '100%',
        backgroundColor: ((_theme_colors = theme.colors) === null || _theme_colors === void 0 ? void 0 : _theme_colors.background) || '#ffffff',
        padding: ((_theme_spacing = theme.spacing) === null || _theme_spacing === void 0 ? void 0 : _theme_spacing.lg) || '1.5rem',
        borderRadius: ((_theme_radius = theme.radius) === null || _theme_radius === void 0 ? void 0 : _theme_radius.md) || '0.5rem',
        boxShadow: ((_theme_shadows = theme.shadows) === null || _theme_shadows === void 0 ? void 0 : _theme_shadows.sm) || '0 2px 4px rgba(0, 0, 0, 0.1)',
        margin: "".concat(((_theme_spacing1 = theme.spacing) === null || _theme_spacing1 === void 0 ? void 0 : _theme_spacing1.lg) || '1.5rem', " 0"),
        fontFamily: ((_theme_typography = theme.typography) === null || _theme_typography === void 0 ? void 0 : _theme_typography.fontFamily) || '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif'
    }, "@media (max-width: ".concat(((_theme_breakpoints = theme.breakpoints) === null || _theme_breakpoints === void 0 ? void 0 : _theme_breakpoints.sm) || '640px', ")"), {
        padding: ((_theme_spacing2 = theme.spacing) === null || _theme_spacing2 === void 0 ? void 0 : _theme_spacing2.sm) || '0.5rem',
        margin: "".concat(((_theme_spacing3 = theme.spacing) === null || _theme_spacing3 === void 0 ? void 0 : _theme_spacing3.sm) || '0.5rem', " 0")
    });
});
var IsolatedHtmlWrapper = styled.div(function(param) {
    var theme = param.theme;
    var _theme_colors, _theme_typography_fontSize, _theme_typography, _theme_typography1, _theme_spacing, _theme_spacing1, _theme_spacing2, _theme_spacing3, _theme_spacing4, _theme_spacing5, _theme_spacing6, _theme_spacing7, _theme_spacing8, _theme_spacing9, _theme_colors1, _theme_spacing10, _theme_spacing11, _theme_colors2, _theme_colors3, _theme_spacing12, _theme_colors4, _theme_colors5;
    return {
        width: '100%',
        '& *': {
            boxSizing: 'border-box',
            margin: 0,
            padding: 0
        },
        color: ((_theme_colors = theme.colors) === null || _theme_colors === void 0 ? void 0 : _theme_colors.text) || '#333',
        lineHeight: '1.5',
        fontSize: ((_theme_typography = theme.typography) === null || _theme_typography === void 0 ? void 0 : (_theme_typography_fontSize = _theme_typography.fontSize) === null || _theme_typography_fontSize === void 0 ? void 0 : _theme_typography_fontSize.base) || '1rem',
        fontFamily: ((_theme_typography1 = theme.typography) === null || _theme_typography1 === void 0 ? void 0 : _theme_typography1.fontFamily) || '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
        '& h1, & h2, & h3, & h4, & h5, & h6, & p, & div, & span, & ul, & ol, & li': {
            display: 'block',
            marginBottom: ((_theme_spacing = theme.spacing) === null || _theme_spacing === void 0 ? void 0 : _theme_spacing.sm) || '0.5rem'
        },
        '& h1': {
            fontSize: '2em',
            fontWeight: 'bold',
            marginTop: ((_theme_spacing1 = theme.spacing) === null || _theme_spacing1 === void 0 ? void 0 : _theme_spacing1.lg) || '1.5rem',
            marginBottom: ((_theme_spacing2 = theme.spacing) === null || _theme_spacing2 === void 0 ? void 0 : _theme_spacing2.md) || '1rem',
            fontFamily: '"Comic Sans MS", "Comic Sans", cursive, -apple-system, BlinkMacSystemFont, sans-serif',
            color: 'inherit'
        },
        '& h2': {
            fontSize: '1.5em',
            fontWeight: 'bold',
            marginTop: ((_theme_spacing3 = theme.spacing) === null || _theme_spacing3 === void 0 ? void 0 : _theme_spacing3.md) || '1rem',
            marginBottom: ((_theme_spacing4 = theme.spacing) === null || _theme_spacing4 === void 0 ? void 0 : _theme_spacing4.sm) || '0.5rem',
            fontFamily: '"Comic Sans MS", "Comic Sans", cursive, -apple-system, BlinkMacSystemFont, sans-serif',
            color: 'inherit'
        },
        '& p': {
            marginBottom: ((_theme_spacing5 = theme.spacing) === null || _theme_spacing5 === void 0 ? void 0 : _theme_spacing5.sm) || '0.5rem',
            fontFamily: 'inherit'
        },
        '& ul, & ol': {
            paddingLeft: ((_theme_spacing6 = theme.spacing) === null || _theme_spacing6 === void 0 ? void 0 : _theme_spacing6.xl) || '2rem',
            marginBottom: ((_theme_spacing7 = theme.spacing) === null || _theme_spacing7 === void 0 ? void 0 : _theme_spacing7.md) || '1rem'
        },
        '& li': {
            display: 'list-item',
            marginBottom: ((_theme_spacing8 = theme.spacing) === null || _theme_spacing8 === void 0 ? void 0 : _theme_spacing8.xs) || '0.25rem'
        },
        '& table': {
            display: 'table',
            width: '100%',
            borderCollapse: 'collapse',
            margin: "".concat(((_theme_spacing9 = theme.spacing) === null || _theme_spacing9 === void 0 ? void 0 : _theme_spacing9.md) || '1rem', " 0"),
            border: "1px solid ".concat(((_theme_colors1 = theme.colors) === null || _theme_colors1 === void 0 ? void 0 : _theme_colors1.border) || '#ddd')
        },
        '& caption': {
            display: 'table-caption',
            textAlign: 'center',
            fontWeight: 'bold',
            padding: ((_theme_spacing10 = theme.spacing) === null || _theme_spacing10 === void 0 ? void 0 : _theme_spacing10.sm) || '0.5rem',
            captionSide: 'top',
            fontFamily: 'inherit'
        },
        '& thead': {
            display: 'table-header-group'
        },
        '& tbody': {
            display: 'table-row-group'
        },
        '& tr': {
            display: 'table-row'
        },
        '& th': {
            display: 'table-cell',
            padding: ((_theme_spacing11 = theme.spacing) === null || _theme_spacing11 === void 0 ? void 0 : _theme_spacing11.sm) || '0.5rem',
            textAlign: 'left',
            fontWeight: 'bold',
            backgroundColor: ((_theme_colors2 = theme.colors) === null || _theme_colors2 === void 0 ? void 0 : _theme_colors2.muted) || '#f2f2f2',
            border: "1px solid ".concat(((_theme_colors3 = theme.colors) === null || _theme_colors3 === void 0 ? void 0 : _theme_colors3.border) || '#ddd'),
            fontFamily: 'inherit'
        },
        '& td': {
            display: 'table-cell',
            padding: ((_theme_spacing12 = theme.spacing) === null || _theme_spacing12 === void 0 ? void 0 : _theme_spacing12.sm) || '0.5rem',
            border: "1px solid ".concat(((_theme_colors4 = theme.colors) === null || _theme_colors4 === void 0 ? void 0 : _theme_colors4.border) || '#ddd'),
            fontFamily: 'inherit'
        },
        '& code, & pre': {
            fontFamily: '"SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier, monospace',
            backgroundColor: ((_theme_colors5 = theme.colors) === null || _theme_colors5 === void 0 ? void 0 : _theme_colors5.codeBg) || '#f5f5f5',
            padding: '3px 5px',
            borderRadius: '3px'
        },
        '& strong': {
            fontWeight: 'bold'
        },
        '& em': {
            fontStyle: 'italic'
        },
        '@keyframes fadeIn': {
            from: {
                opacity: 0,
                transform: 'translateY(20px)'
            },
            to: {
                opacity: 1,
                transform: 'translateY(0)'
            }
        },
        '@keyframes bounce': {
            '0%, 100%': {
                transform: 'translateY(0)'
            },
            '50%': {
                transform: 'translateY(-10px)'
            }
        },
        '& .fade-in': {
            animation: 'fadeIn 0.8s ease-out'
        },
        '& .bounce': {
            animation: 'bounce 1.5s infinite'
        }
    };
});
var processHtmlContent = function(content) {
    return content.replace(/font-family: 'Comic Sans MS'/g, 'font-family: "Comic Sans MS", "Comic Sans", cursive').replace(/font-family: Comic Sans MS/g, 'font-family: "Comic Sans MS", "Comic Sans", cursive');
};
var HtmlComponent = function(param) {
    var htmlContent = param.htmlContent, children = param.children;
    var theme = useTheme();
    // Support both htmlContent prop and children
    var content = htmlContent || (typeof children === 'string' ? children : '');
    if (!content) {
        return null;
    }
    var processedContent = processHtmlContent(content);
    return /*#__PURE__*/ React.createElement(HtmlComponentContainer, null, /*#__PURE__*/ React.createElement(IsolatedHtmlWrapper, {
        dangerouslySetInnerHTML: {
            __html: processedContent
        }
    }));
};
export default HtmlComponent;
